import { jsx as _jsx } from "react/jsx-runtime";
import { Provider, symbolToken } from '@servicetitan/react-ioc';
export const CULTURE_TOKEN = symbolToken('CULTURE_TOKEN');
export const CultureProvider = ({ value, children }) => {
    return (_jsx(Provider, { singletons: value ? [{ provide: CULTURE_TOKEN, useValue: value }] : undefined, children: children }));
};
//# sourceMappingURL=index.js.map